module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/florists-tile-f7c8148c8b35d30bde872591bb8e9e3a.jpg";